import { NavBar } from 'components/NavBar/NavBar'
import { Receiving } from 'pages/Procurement/Tabs/Receiving'
import { Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'

export const InventoryReceiving = () => {
  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <MainHeadline>Receiving</MainHeadline>
        </Flex>
        <Receiving standalone />
      </PageWrapper>
    </>
  )
}
